"use strict";

var _ValueCache = _interopRequireDefault(require("./ValueCache"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ValuesCache manages many ValueCache objects with names
 * for convenience.
 **/
class ValuesCache {
  constructor(options = {}) {
    this.caches = {};
    this.equals = options.equals;
  }
  /**
   * Returns, creating if necessary the ValueCache for
   * the given key
   * @param {string} key the name of the ValueCache to get/create
   * @return {ValueCache} the ValueCache with the name
   **/


  cache(key) {
    if (this.caches[key] == null) {
      this.caches[key] = new _ValueCache.default({
        equals: this.equals
      });
    }

    return this.caches[key];
  }
  /**
   * Returns true if the supplied conditions are the same as the 
   * ones given last time
   * @param {string} key the name of the ValueCache to check
   * @param {...any} conditions the variables used to
   * decide whether or not the cached value can be reused
   * @return {boolean} true if the cached value can be used
   **/


  isSame(key, ...conditions) {
    return this.cache(key).isSame(...conditions);
  }
  /**
   * Returns the last cachec value for the given key
   * @param {string} key the name of the ValueCache whose
   * value should be returned
   * @return {any} the value
   **/


  value(key) {
    return this.cache(key).value;
  }
  /**
   * Sets the named cached values and the variable used
   * to compute it. The value is returned
   * @param {string} key the name of the ValueCache to set
   * @param {any} value the value to cache
   * @param {...any} the variables used to compute the value
   * @return {any} the value
   **/


  set(key, value, ...conditions) {
    return this.cache(key).set(value, ...conditions);
  }
  /**
   * Clears the cached value and the conditions stored
   * at the given key
   * @param {string} key the name of the ValueCache to clear
   **/


  clear(key) {
    return this.cache(key).clear();
  }
  /**
   * Clears all of the cached values and their conditions
   **/


  clearAll() {
    this.caches = {};
  }
  /**
   * Optional way of using ValuesCache to check and compute in one step
   * @param {string} the name of the value to cache
   * @param {function} compute a function of form function( ...conditions )
   * that computes and returns the value
   * @param {...any} conditions the set of conditions that define the value
   * @return {any} either the cached value or the newly computed one
   **/


  calc(key, compute, ...conditions) {
    return this.cache(key).calc(compute, ...conditions);
  }

}

module.exports = ValuesCache;